import { constants } from "@newsela/angelou";

import { GUIDED_HIGHLIGHTING_ANNOTATION_STYLES } from "@/view/TiptapArticleBody/extensions/TextHighlighting/GuidedHighlighting";

const { ui } = constants.colors;

export interface IReadingSkillColor {
  name: string;
  color: string;
  BadgeColor: string;
}

export type TReadingSkillIndex =
  | "people_places_events"
  | "what_the_text_says"
  | "text_evidence"
  | "default";

export const GUIDED_HIGHLIGHTING_SKILLS_META: Record<
  TReadingSkillIndex,
  IReadingSkillColor
> = {
  what_the_text_says: {
    name: "What the text says",
    color: ui.purple[25],
    BadgeColor: ui.purple[400],
  },
  people_places_events: {
    name: "People, places and events",
    color: ui.blue[50],
    BadgeColor: ui.blue[400],
  },
  text_evidence: {
    name: "Text evidence",
    color: ui.pink[25],
    BadgeColor: ui.pink[400],
  },
  default: {
    name: "",
    color: GUIDED_HIGHLIGHTING_ANNOTATION_STYLES.default.textColor,
    BadgeColor: GUIDED_HIGHLIGHTING_ANNOTATION_STYLES.default.badgeColor,
  },
};
